
import api from '../../api/vo2api'

import Vue from 'vue'
import Vuex from 'vuex'
import errors from "./Errors";


Vue.use(Vuex);


let userAccount = new class {
    constructor() {

        this.state = {
            currentId: null,
            current: null,
            currentLoading: false,
            currentLoadingError: false,
            currentLoadingErrorValue: null,
        };

        this.getters = {
            currentId:(state) => state.currentId,
            current:(state) => state.current,
            currentLoading:(state) => state.currentLoading,
            currentLoadingError: (state) => state.currentLoadingError,
            currentLoadingErrorValue: (state) => state.currentLoadingErrorValue,


            currentName:(state) => {
                let name = '-';
                let current = state.current;
                if(current){
                    let first = current.firstName;
                    let last = current.lastName;
                    let email = current.emailAddress;
                    let id = current.userAccountId;

                    name = '';
                    if(first !== undefined && first !== '') {
                        name = first;
                    }
                    if(last !== undefined && last !== '') {
                        name = name + ' ' + last;
                    }
                    if(name === '' && email !== undefined && email !== '') {
                        name = email;
                    }
                    if(name === '' && id !== undefined && id !== '') {
                        name = '#' + id;
                    }
                }

                return name;
            },

        };

        this.mutations = {
            setCurrent (state, { id, model }) {
                state.currentId = id
                state.current = model
            },
            setCurrentLoading (state, value) {
                state.currentLoading = value
            },
            setCurrentLoadingError (state, value) {
                state.currentLoadingError = value
            },
            setCurrentLoadingErrorValue (state, value) {
                state.currentLoadingErrorValue = value
            },
        };

        this.actions = {

            login({ commit }) {

                commit('setCurrent', {});
                commit('setCurrentLoadingError', false);
                commit('setCurrentLoadingErrorValue', null);

                commit('setCurrentLoading', true);
                return api.login().then( res => {

                    let model = res;
                    let id = res.userAccountId;
                    if(!id || !model) {
                        commit('setCurrentLoadingError', true);
                        commit('setCurrentLoadingErrorValue', 'internal error');
                        commit('setCurrent', {});
                        return null;
                    } else {
                        commit('setCurrent', {id, model});
                        return model;
                    }
                }).catch(function (error) {
                    // handle error
                    console.log(error);
                    commit('setCurrentLoadingError', true);
                    commit('setCurrentLoadingErrorValue', errors.parseError(error));
                    return null;
                }).then(value => {
                    commit('setCurrentLoading', false);
                    return value;
                });
            },

            save ({  commit, rootState }, entity ) {

                if(entity) {

                    let id = rootState.userAccount.currentId;

                    commit('setCurrentLoading', true);

                    return api.insertOrUpdateUserAccount(id, entity)
                        .then(model => {
                            commit('setCurrent', { id, model })
                            return model != null
                        }).catch(function (error) {
                            // handle error
                            console.log(error);
                            return false
                        }).then(value => {
                            commit('setCurrentLoading', false)
                            return value
                        });
                }

                return new Promise(resolve => resolve(false));
            },

        }

    }

}

const state = {
    ...userAccount.state,
};
const getters = {
    ...userAccount.getters,
};
const actions = {
    ...userAccount.actions,
};
const mutations = {
    ...userAccount.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
